import { Button, CircularProgress, Stack } from '@mui/material';

type NavRowProps = {
  handleBack?: () => void;
  handleNext?: () => void;

  justify?: 'left' | 'right' | 'space-between';

  backButtonText?: string;
  nextButtonText?: string;

  hideBackButton?: boolean;
  disableNext?: boolean;

  loadingNext?: boolean;

  sx?: React.ComponentProps<typeof Stack>['sx'];
};

const defaultSx: React.ComponentProps<typeof Stack>['sx'] = {
  pt: 2,
  width: '100%',
};

export const NavRow: React.FC<NavRowProps> = ({
  sx,
  handleBack = () => {},
  handleNext = () => {},
  justify = 'space-between',
  disableNext,
  hideBackButton = false,
  backButtonText = 'Zurück',
  nextButtonText = 'Weiter',
  loadingNext = false,
}) => {
  return (
    <Stack
      sx={{ ...defaultSx, ...sx }}
      direction='row-reverse'
      justifyContent={justify}
    >
      <Button
        type='submit'
        onClick={handleNext}
        variant='contained'
        disabled={disableNext}
      >
        <span>{nextButtonText}</span>
        {loadingNext && <CircularProgress size={20} />}
      </Button>

      {!hideBackButton && (
        <Button variant='outlined' onClick={handleBack} sx={{ mr: 1 }}>
          {backButtonText}
        </Button>
      )}
    </Stack>
  );
};
